<template>
  <div class="input-group">
    <label class="control-label" :for="field_name">{{ label }}</label>
    <div class="input-group">
            <textarea v-if="type === 'textarea'" class="form-control" :id="field_name" v-model="localValue"
                      @input="update"></textarea>
      <input v-else class="form-control" type="text" :id="field_name" :placeholder="placeholder" v-model="localValue"
             @keyup.delete="update" @input="update"/>
      <div class="input-group-addon" v-html="statusClass">
      </div>
    </div>
    <span class="help is-danger" v-if="errors.has(field_name)"
          v-text="errors.get(field_name)"></span>
  </div>
</template>

<script>
import {Errors} from './TForm';

export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      required: true,
    },
    nullable: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
    },
    field_name: {
      type: String,
      required: true,
    },
    route: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      localValue: this.value,
      sending: false,
      dirty: false,
      timeout: undefined,
      errors: new Errors(),
    };
  },
  computed: {
    statusClass() {
      if (this.sending) {
        return '<ion-icon name="sync" class="md-hydrated">';
      }
      if (this.dirty) {
        return '<ion-icon name="create" class="md-hydrated">';
      }
      return '<ion-icon name="checkmark" class="md-hydrated">';
    },
  },
  watch: {
    localValue(newValue, oldValue) {
      if (newValue || this.nullable) {
        this.dirty = true;
        this.errors.clear();
        this.delayedUpdate();
      }
    },
  },
  methods: {
    delayedUpdate() {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = undefined;
      }
      this.timeout = setTimeout(this.sendUpdate, 1500);
    },
    update() {
      this.$emit('input', this.localValue);
    },
    sendUpdate() {
      this.timeout = undefined;
      this.sending = true;
      let data = {};
      data[this.field_name] = this.localValue;
      axios.patch(this.route, data, {
        headers: {
          'Content-Type': 'application/json',
          // 'X-CSRF-TOKEN': token.content,
          'X-Requested-With': 'XMLHttpRequest',
        },
      }).then(response => {
        this.sending = false;
        this.dirty = false;
      }).catch(error => {
        this.errors.record(error.response.data);
      });
    },
  },
};
</script>
